// extracted by mini-css-extract-plugin
module.exports = {"shadowedBox":"MediaCard_shadowedBox__Nun6d","titleDiv":"MediaCard_titleDiv__vSNbs","subtitle":"MediaCard_subtitle__EBRSh"};